export const enTranslations = {
  qe: {
    title: 'Quick Enrollment',
    intro: 'You will need to complete this enrollment in one sitting - your information cannot be saved unless all fields are completed.',
    language_label: 'Language',
    sections: {
      personal_info: 'Personal Information',
      personal_address: 'Personal Address',
      company_info: 'Company Information',
      dependent_info: 'Dependent Information',
      plan_selection: 'Plan Selection',
      payment_method: 'Payment Method',
      saved_payment: 'Saved Payment Method',
      summary: 'Summary',
      required_documents: 'Required Documents',
      required_documents_subtitle: 'Please upload the required documents listed below.',
    },
    labels: {
      email: 'Email:',
      dob: 'Date of Birth:',
      ssn: 'SSN:',
      first_name: 'First Name:',
      middle_name: 'Middle Name:',
      last_name: 'Last Name:',
      suffix: 'Suffix:',
      gender: 'Gender:',
      marital_status: 'Marital Status:',
      mobile_phone: 'Mobile Phone:',
      confirm_email: 'Confirm Email:',
      tobacco: 'Does Person Use Tobacco ?',
      employee_id: 'Employee ID:',
      payroll_contact_name: 'Payroll Contact Name:',
      payroll_contact_phone: 'Payroll Contact Phone:',
      address: 'Address:',
      city: 'City:',
      state: 'State:',
      zip_code: 'Zip Code:',
      company_name: 'Company Name:',
      employer_name: 'Employer Name:',
      ein: 'Employer Identification Number (EIN):',
      entity_type: 'Entity Type:',
      billing_email: 'Billing Email:',
      nerds_number: 'NERDS Number',
      association_name: 'Association Name',
      agent_number: 'Agent Number',
      relation: 'Relation:',
      select_payment_type: 'Select payment type',
      type_name_here: 'Type your name here:',
      authorization_checkbox:
        'By checking the box, I acknowledge that I understand and agree to the authorization.',
    },
    placeholders: {
      email: 'Email',
      dob: 'DOB',
      ssn: 'SSN',
      first_name: 'First Name',
      middle_name: 'Middle Name',
      last_name: 'Last Name',
      suffix: 'Suffix',
      gender: 'Gender',
      marital_status: 'Marital Status',
      mobile_phone: 'Mobile Phone',
      confirm_email: 'Confirm Email',
      tobacco: 'Does Person Use Tobacco ?',
      employee_id: 'Employee ID',
      payroll_contact_name: 'Payroll Contact Name',
      payroll_contact_phone: 'Payroll Contact Phone',
      address: 'Address',
      city: 'City',
      state: 'State',
      zip_code: 'Zip Code',
      company_name: 'Company Name',
      employer_name: 'Employer Name',
      ein: 'Employer Identification Number (EIN)',
      entity_type: 'Entity Type',
      billing_email: 'Billing Email',
      nerds_number: 'NERDS Number',
      association_name: 'Association Name',
      agent_number: 'Agent Number',
      relation: 'Relation',
      signature:
        'Your name entered in this field will be considered as your electronic signature.',
      select_file: 'Select File',
    },
    options: {
      suffix: 'Suffix',
      gender: 'Gender',
      marital_status: 'Marital Status',
      entity_type: 'Entity Type',
      state: 'State',
      relation: 'Relation',
      tobacco_yes: 'Yes',
      tobacco_no: 'No',
    },
    buttons: {
      continue: 'Continue',
      save_select_plans: "Save details & select your plan(s)",
      update_select_plans: "Update details & select your plan(s)",
      submit: 'Submit',
      add_family_member: 'Add Family Member',
      add_payment: 'Add Payment',
      cancel_payment: 'Cancel',
      select_plan: 'Select Plan',
      selected_plan: 'Selected Plan',
      waive_coverage: 'Waive Coverage',
      coverage_waived: 'Coverage Waived',
      view_benefit_details: 'View Benefit Details',
      benefit_details_header: 'Benefit Details',
      ok: 'Ok',
      close: 'X',
      delete: 'Delete',
      restore_spouse: 'Restore Deleted Spouse',
      upload: 'Upload',
      reupload: 'Reupload',
      refresh: 'Refresh',
    },
    coverage: {
      please_select: 'Please select',
      myself: 'Myself',
      select_tier: 'Please Select Tier of Coverage:',
      plan_col_header: 'Name',
      enrolled_col_header: 'Selection',
      no_plans_found: 'No plans found',
      optional_addons: 'Optional Add-on(s)',
      dependent_number: 'Dependent - {{number}}',
      dependent_label: 'Dependent {{number}}',
    },
    payment: {
      payment_selected: 'Payment method selected successfully.',
      credit_card: 'Credit Card',
      ach: 'ACH',
    },
    summary_table: {
      plan: 'Plan',
      enrolled: 'Enrolled',
      employee_contribution: 'Employee Contribution',
      total_contribution: 'Total Employee Contribution:',
    },
    payment_table: {
      nickname: 'Nickname',
      type: 'Type',
      identifier: 'Identifier',
      last_4: 'Last 4',
      name: 'Name',
      expires_on: 'Expires On',
      account_name: 'Account Name',
      account_number: 'Account Number',
      routing_number: 'Routing Number',
      account_type: 'Account Type',
      entry_method: 'Entry Method',
      default: 'Default',
    },
    otp: {
      code_sent: 'A 6-digit verification code has been sent to {{email}}. Please enter it below to verify your identity and continue.',
      title: 'Passcode Verification',
      placeholder: 'Enter a passcode',
      verify: 'Verify Passcode',
      resend_in: 'Resend in {{seconds}}s',
      resend: "Haven't received the code? Resend.",
      attempts_exceeded: 'You exceeded 5 passcode attempts. Resend.',
      back: 'Back',
    },
    errors: {
      email_required: 'Email is required.',
      valid_email: 'Please enter a valid email',
      dob_required: 'Date of Birth is required.',
      ssn_required: 'SSN is required.',
      valid_ssn: 'Please enter a valid SSN.',
      first_name_required: 'First Name is required.',
      last_name_required: 'Last Name is required.',
      gender_required: 'Gender is required.',
      marital_status_required: 'Marital Status is required.',
      mobile_phone_required: 'Mobile Phone is required.',
      confirm_email_required: 'Confirm Email is required.',
      valid_confirm_email: 'Please enter a valid Confirm Email.',
      tobacco_required: 'Tobacco is required.',
      address_required: 'Address is required.',
      city_required: 'City is required.',
      state_required: 'State is required.',
      zip_required: 'Zip Code is required.',
      valid_zip: 'Enter a valid Zip Code.',
      company_name_required: 'Company Name is required.',
      employer_name_required: 'Employer Name is required.',
      ein_required: 'EIN(Employer Identification Number) is required.',
      entity_type_required: 'Entity Type is required.',
      billing_email_required: 'Billing Email is required.',
      valid_billing_email: 'Enter a valid Billing Email.',
      association_name_required: 'Association Name is required.',
      agent_number_required: 'Agent Number is required.',
      company_street_required: 'Company Street Address is required.',
      company_city_required: 'Company City is required.',
      company_state_required: 'Company State is required.',
      company_zip_required: 'Company Zip Code is required.',
      zip_only_numbers: 'Zip Code only numeric values allowed.',
      zip_invalid: 'Invalid Zip Code.',
      relation_required: 'Relation is required.',
      signature_required: 'Type your name here is required.',
      disclaimer_required: 'Please check the disclaimer.',
      mobile_phone_only_numbers: 'Mobile Phone only numeric values allowed.',
      phone_number_length: 'Phone number length should be 10 digit.',
      payroll_phone_number: 'Payroll Contact Phone number length should be 10 digit.',
      email_confirm_not_match: 'Email confirmation does not match.',
      select_payment_type: 'Select Payment Type.',
      session_expired: 'Your session has expired. Please re-authenticate to verify your identity and continue.',
      payment_method_required: 'Payment Method is required.',
      multiple_spouse: 'Cannot select multiple spouses or Domestic Partner.',
      dependent_ssn_unique: 'The dependent SSN must be unique.',
      plans_not_found: 'We are unable to locate your plans, please contact your employer.',
      select_at_least_one_plan: 'Please select at least one plan.',
      select_plan_type: 'Please select a {{planType}} plan.',
      failed_payment: 'The payment failed due to {{error}}. Please return to the enrollment form and resubmit the enrollment.',
      common_error: 'Something went wrong. Please contact administrator.',
      valid_credit_card_details: 'Enter a valid credit card details.',
      valid_bank_account_details: 'Enter a valid bank account details.',
      name_on_account_required: 'Name on Account is required.',
      valid_routing_number: 'Enter a valid Routing Number.',
      valid_account_number: 'Enter a valid Account Number.',
      valid_card_number: 'Enter a valid credit card number.',
      valid_card_expiry: 'Enter a valid credit card expiry date.',
      valid_card_cvv: 'Enter a valid cvv number.',
      name_on_card_required: 'Name on The Card is required.',
      invalid_url: 'Invalid URL.',
      billing_schedule_error: 'Invalid Billing schedule, Please contact administrator.',
      file_required: 'Please choose a file to upload.',
      // IES-5491
      product_not_available_for_tier: 'This product is not available for the "{{tier}}" coverage tier.',
      products_not_available_for_tier: 'These products are not available for the "{{tier}}" coverage tier.',
      dependent_relation_not_allowed: '{{relation}} dependents are not available for this employer\'s product coverage.',
    },
    modal: {
      failed_payment_title: 'Failed Payment',
    },
    payment_modal: {
      add_credit_card: 'Add Credit Card',
      add_ach: 'Add ACH',
      disclaimer_label: 'Disclaimer:',
      card_number: 'Card Number',
      expiration_date: 'Expiration Date',
      cvv: 'CVV',
      name_on_card: 'Name On The Card',
      use_current_address: 'Use my current address information',
      first_name: 'First Name',
      last_name: 'Last Name',
      email: 'Email',
      address: 'Address',
      city: 'City',
      state: 'State',
      select_state: 'Select State',
      zip_code: 'Zip Code',
      cancel: 'Cancel',
      save_information: 'Save Information',
      name_on_account: 'Name on Account',
      routing_number: 'Routing Number',
      account_number: 'Account Number',
      account_type: 'Account Type',
      personal_checking: 'Personal Checking',
      personal_savings: 'Personal Savings',
      business_checking: 'Business Checking',
      business_savings: 'Business Savings',
    },
    success: {
      enrollment_with_payment: 'Thank you for submitting the enrollment. Your payment has been successfully submitted. If you are paying via ACH (Bank account), the payment will only clear in 4 business days. If it fails, a member of our team will contact you via email. Please expect a Welcome Email within the next 24 hours. It will provide information on how you can access the portal and your plan details.',
      enrollment_without_payment: 'Your enrollment is complete and submitted for processing. Thank you.',
    },
  },
  api_values: {
    // Plan types
    medical: 'Medical',
    dental: 'Dental',
    life: 'Life',
    vision: 'Vision',
    disability: 'Disability',
    accident: 'Accident',
    critical_illness: 'Critical Illness',
    std: 'Short-Term Disability',
    ltd: 'Long-Term Disability',
    hospital: 'Hospital',
    ancillary: 'Ancillary',
    health_share: 'Health Share',
    holistic: 'Holistic',
    hospital_indemnity: 'Hospital Indemnity',
    tobacco: 'Tobacco',
    dpc: 'DPC',
    fee: 'Fee',
    mec: 'MEC',
    voluntary_life: 'Voluntary Life',
    life_child: 'Life - Child',
    life_spouse: 'Life - Spouse',
    flex: 'FLEX',
    legal: 'LEGAL',
    eap: 'EAP',
    flex_dependent: 'FLEX - Dependent',
    hsa: 'HSA',
    // Coverage levels — full names
    employee_only: 'Employee Only',
    employee_spouse: 'Employee + Spouse',
    employee_children: 'Employee + Children',
    employee_family: 'Employee + Family',
    myself: 'Myself',
    myself_and_spouse: 'Myself and Spouse',
    myself_and_children: 'Myself and Children',
    family: 'Family',
    // Coverage levels — short codes
    ee: 'Employee Only',
    es: 'Employee + Spouse',
    ec: 'Employee + Children',
    ef: 'Employee + Family',
    // Enrollment categories (summary)
    self: 'Self',
    self_spouse: 'Self+Spouse',
    self_child: 'Self+Child',
    // Payment types
    ach: 'ACH',
    cc: 'Credit Card',
    credit_card: 'Credit Card',
    invoice: 'Invoice',
    // Account types
    checking: 'Checking',
    savings: 'Savings',
    // Entry methods
    manual: 'Manual',
    online: 'Online',
    swipe: 'Swipe',
    // Gender
    male: 'Male',
    female: 'Female',
    // Marital status
    single: 'Single',
    married: 'Married',
    domestic_partner: 'Domestic Partner',
    legally_separated: 'Legally Separated',
    divorced: 'Divorced',
    widowed: 'Widowed',
    // Entity types
    individual_sole_proprietor_or_single_member_llc: 'Individual/sole proprietor or single-member LLC',
    c_corporation: 'C Corporation',
    s_corporation: 'S Corporation',
    partnership: 'Partnership',
    trust_estate: 'Trust/Estate',
    llc_partnership: 'LLC, Partnership',
    llc_c_corp: 'LLC, C corp',
    llc_s_corp: 'LLC, S corp',
    // Dependent relations
    spouse: 'Spouse',
    child: 'Child',
    disabled_child: 'Disabled Child',
    // Name suffixes (universal across languages)
    sr: 'Sr',
    jr: 'Jr',
    i: 'I',
    ii: 'II',
    iii: 'III',
    iv: 'IV',
  },
};
